import React from 'react';
import { Form, Input, Button, message, Card, Tooltip } from 'antd';
// import { Form, Input, Button, message, Card, Tabs } from 'antd';
import common from "../assets/common.js";
import './login.css';
import logo from '../images/login/logo.png';
import police from '../images/police.png';
import user from '../images/login/user.svg';
import pass from '../images/login/pass.svg';

const FormItem = Form.Item;
// const validateUrl = "/tollhouse/valid-image";
// const TabPane = Tabs.TabPane;

class Login extends React.Component {
  state = {
    time: new Date().getTime(),
  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        var postData = values;
        postData["_url"] = "api/admin/login";
        common.request(postData, this, function(obj, data){
          if(!data.result.superAdmin) {
            obj.props.history.push('manage/user');
          } else {
            obj.props.history.push('school');
          }
          window.location.reload();
        },function(obj, data) {
          obj.reValidateUrl();
          message.warning(data.message);
        })
      }
    });
  }

  /**
   * 刷新验证码
   */
  reValidateUrl = () => {
    // 以下URL带上了版本号v，原因如下：
    // URL相同时，火狐浏览器及edge浏览器认为验证码图片没有改变，导致无法刷新验证码
    this.setState({
      time : new Date().getTime(),
    });
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    const { time } = this.state;
    const validImg = "valid-image?v=" + time;
    const formItemLayout = {
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
      },
    };

    return (
      <div id="loginMainMain">
        <div id="loginMainDiv">
          <div id="loginMain">
            <div id="loginMainL"></div>
            <div id="loginBanner">
              <div style={{height: 60,backgroundColor: "#FFF"}}>
                <div id="loginLogo">
                  <a href="https://www.yunban.com">
                    <img src={ logo } alt="" width="50%"/>
                  </a>
                </div>
              </div>
              <Card id="loginFormCard">
                <div>
                  <div id="loginTitle">
                    账号登录
                  </div>
                  <div  id="loginContent">
                    <Form onSubmit={this.handleSubmit} id="loginForm" className="form-login">
                      <FormItem
                      { ... formItemLayout }
                      >
                        {getFieldDecorator('userName', {
                          rules: [{
                            required: true, message: '请输入用户名'
                          }],
                        })(
                          <Input addonBefore={<img className="input-icon" src={ user } alt=""/>} placeholder="请输入账号" />
                        )}
                      </FormItem>
                      <FormItem
                      { ... formItemLayout }
                      >
                        {getFieldDecorator('passWord', {
                          rules: [{ required: true, message: '请输入密码' }],
                        })(
                          <Input type="password" addonBefore={<img className="input-icon" src={ pass } alt=""/>} placeholder="请输入密码" />
                        )}
                      </FormItem>
                      <FormItem
                      { ... formItemLayout }
                      >
                        {getFieldDecorator('code', {
                          rules: [{ required: true, message: '请输入验证码' }],
                        })(
                          <Input style={{ width : "58%" }} addonBefore={<img className="input-icon" src="images/login/valid.svg" alt=""/>} placeholder="请输入验证码" />
                        )}
                        <a onClick={() => this.reValidateUrl()}>
                          <Tooltip title="看不清？换一个" placement="right">
                            <img id="vilidateImg" src={ validImg } alt="验证码" />
                          </Tooltip>

                        </a>
                      </FormItem>
                      <FormItem
                        className="formItem-btn"
                      { ... formItemLayout }
                      >
                        <Button id="loginBtn" type="primary" htmlType="submit" style={{ width:"100%"}} className="login-form-button">  登录  </Button>
                      </FormItem>
                    </Form>
                  </div>
                </div>
              </Card>
            </div>

          </div>
        </div>
        <div id="footer" className="text-center">
          Copyright © 2012 - 2023 Yunban. All Rights Reserved.云瓣科技有限公司版权所有 云瓣法律顾问：易法通 沪ICP备14019811号-2 <a style={{color: "#FFF"}} href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502013871" target="_blank">沪公网安备 31011502013871号<img class="police" src={ police } alt/></a>
        </div>
      </div>
    );
  }
}

const LoginForm = Form.create()(Login);
export default LoginForm;



// WEBPACK FOOTER //
// ./src/index/login.js